import { axiosInstance } from "src/store/base/store/axios";
import constants from "./constants";

export async function markNonFaults({ markAsOk, id }) {
  await axiosInstance.post(`${constants.MARK_NON_FAULTS_URL}${id}/`, {
    to_is_ok: markAsOk ? true : false,
  });
}
